import React, { useEffect, useRef, useState, useCallback } from "react";
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import $ from "jquery";
import Swal from "sweetalert2";
import moment from "moment";
import { isEmpty } from "lodash";
import Hls from "hls.js";
import * as action from "../../Action/Episodes/Episodes_Action";
import * as Authservices from "../../Services/services";
import { s3Axios } from "../../Services/services";
import { getTags } from "../../Action/Tags/Tags_Action";
import { getSeriesDetails } from "../../Action/Series/Series_Action";
import Model from "../Model/Index";
import Series from "./Series";
import SeriesDetailHeader from "./SeriesDetailHeader";
import CustomVideoBox from "../UploadPreview/CustomVideoBox";
import NumberDisplay from "../NumberDisplay/Index";
import Select2Component from "../CustomSelect/Select2";
import NumberInput from "../Input/Number";
import { useAuth } from "../../context/Context";
import { usePermission } from "../../hooks/usePermission";

const CDN_BASE = "https://cdn-stg.hikecinema.com";

// Mirrors MAX_EPISODES_PER_REQUEST in cinema-admin-service. Single and bulk upload
// share POST /episode/add — a single episode is a list of one — and the API rejects
// a batch larger than this with a 400.
const MAX_EPISODES_PER_BATCH = 10;

// Statuses that still have work in flight, so polling should keep running.
const IN_FLIGHT_STATUSES = ["queued", "pending", "processing"];

// transcoding_error is a MediaConvert message rendered into a title attribute
// built by string concatenation — escape it so quotes can't break out of the tag.
function escapeHtml(str) {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function resolveHlsUrl(hlsUrl) {
  if (!hlsUrl) return "";
  let url = hlsUrl.trim();
  url = url.replace(/^https?:\/\/[^/]+/, CDN_BASE);
  if (url.endsWith("/")) url = url + "master.m3u8";
  else if (!url.includes(".m3u8")) url = url.replace(/\/?$/, "/master.m3u8");
  return url;
}

const Episodes = ({ id }) => {
  const { user } = useAuth();
  const { canCreate, canEdit, canDelete } = usePermission();
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const updateEpisodesLoading = useSelector(
    (state) => state.UpdateEpisodesReducer,
  );
  const addEpisodesLoading = useSelector((state) => state.AddEpisodesReducer);
  const addEpisodesUrlsLoading = useSelector(
    (state) => state.AddEpisodesUrlsReducer,
  );
  const dataTableInstanceRef = useRef(null);
  const [showModel, setShowModel] = useState({
    show: false,
    title: "Add",
  });
  const [count, setCount] = useState(0);
  const [errors, setErrors] = useState({});
  const [uploadProgress, setUploadProgress] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadStatus, setUploadStatus] = useState("");
  const [videoPopupVisible, setVideoPopupVisible] = useState(false);
  const [currentVideoSrc, setCurrentVideoSrc] = useState("");
  const [hlsLevels, setHlsLevels] = useState([]);
  const [currentQualityIdx, setCurrentQualityIdx] = useState(-1);
  const [showQualityMenu, setShowQualityMenu] = useState(false);
  const cfCredentialsRef = useRef(null);
  const bunnyQsRef = useRef(null);
  const [episodeData, setEpisodeData] = useState({
    id: 0,
    series_id: id,
    episode_number: "",
    coin: 0,
    video_url: "",
    title: "",
    description: "",
    tags: [],
  });
  const [showUrlModel, setUrlModel] = useState(false);
  const [urlFields, setUrlFields] = useState([""]);
  const [tagList, setTagList] = useState([]);
  const [seriesTitle, setSeriesTitle] = useState("");
  const [seriesInfo, setSeriesInfo] = useState(null);
  const [seriesRevision, setSeriesRevision] = useState(0);
  const [filePreview, setFilePreview] = useState("");
  const episodeNumberRefFocus = useRef(null);
  const coinRefFocus = useRef(null);
  const coverVideoRefFocus = useRef(null);
  const titleRefFocus = useRef(null);
  const descriptionRefFocus = useRef(null);
  const tagsRefFocus = useRef(null);
  const hasFetchedRef = useRef(null);
  const videoRef = useRef(null);
  const isSubmittingRef = useRef(false);
  const hlsRef = useRef(null);
  const pollingRef = useRef({});
  const startPollingRef = useRef(null);
  const startBulkPollingRef = useRef(null);
  const rawVideoUrlRef = useRef("");


  // Bulk Upload States
  const [showBulkModel, setShowBulkModel] = useState(false);
  const [isBulkMinimized, setIsBulkMinimized] = useState(false);
  const [bulkEpisodes, setBulkEpisodes] = useState([]);
  const [bulkErrors, setBulkErrors] = useState({});
  const [bulkSubmitting, setBulkSubmitting] = useState(false);
  const [selectedEpisodeId, setSelectedEpisodeId] = useState(null);
  const [existingEpisodes, setExistingEpisodes] = useState([]);
  const [maxEpisodeNumber, setMaxEpisodeNumber] = useState(0);
  const allBulkFilesUploadedRef = useRef(false);

  const updateEpisodeState = (epId, updates) => {
    setBulkEpisodes((prev) =>
      prev.map((ep) => (ep.id === epId ? { ...ep, ...updates } : ep)),
    );
  };

  const updateEpisodeMetadata = (epId, field, value) => {
    setBulkEpisodes((prev) =>
      prev.map((ep) =>
        ep.id === epId
          ? {
              ...ep,
              metadata: {
                ...ep.metadata,
                [field]: value,
              },
            }
          : ep,
      ),
    );
  };

  const removeBulkEpisode = (epId) => {
    setBulkEpisodes((prev) => {
      const filtered = prev.filter((ep) => ep.id !== epId);
      if (selectedEpisodeId === epId) {
        setSelectedEpisodeId(filtered[0]?.id || null);
      }
      return filtered;
    });
    setBulkErrors((prev) => {
      const updated = { ...prev };
      delete updated[epId];
      return updated;
    });
  };

  const uploadBulkFile = async (epId, file) => {
    try {
      updateEpisodeState(epId, { status: "presigning", error: null });

      const presignedRes = await Authservices.getEpisodePresignedUrl({
        filename: file.name,
        content_type: file.type,
      });

      const presignedData =
        presignedRes?.data?.data ||
        presignedRes?.data?.responseDetails ||
        presignedRes?.data;
      const uploadUrl = presignedData?.upload_url;
      const s3Key = presignedData?.s3_key;

      if (!uploadUrl || !s3Key) {
        throw new Error(
          "Presigned URL response is missing upload_url or s3_key",
        );
      }

      updateEpisodeState(epId, {
        status: "uploading",
        s3Key: s3Key,
        uploadUrl: uploadUrl,
        progress: 0,
      });

      await s3Axios.put(uploadUrl, file, {
        headers: { "Content-Type": file.type },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          updateEpisodeState(epId, { progress: percent });
        },
      });

      updateEpisodeState(epId, { status: "completed", progress: 100 });
    } catch (err) {
      console.error(`[Bulk Upload S3] Failed for file ${file.name}:`, err);
      const errMsg =
        err?.response?.data?.message || err?.message || "S3 upload failed";
      updateEpisodeState(epId, { status: "failed", error: errMsg });
    }
  };

  const handleBulkFileSelect = (e) => {
    // The browser's FileList doesn't reliably preserve the order files were
    // clicked in a multi-select (notably reversed on some OS file dialogs),
    // so sort by filename to keep episode ordering deterministic.
    const files = Array.from(e.target.files || []).sort((a, b) =>
      a.name.localeCompare(b.name, undefined, { numeric: true }),
    );
    if (files.length === 0) return;

    // Must match MAX_EPISODES_PER_REQUEST in the admin service — the API rejects
    // a larger batch with a 400.
    if (bulkEpisodes.length + files.length > MAX_EPISODES_PER_BATCH) {
      toast.warn(
        `You can upload a maximum of ${MAX_EPISODES_PER_BATCH} episodes at once.`,
      );
      return;
    }

    const newEpisodes = files.map((file, idx) => {
      const tempId = Math.random().toString(36).substring(2, 9);
      const nextEpNum = maxEpisodeNumber + bulkEpisodes.length + idx + 1;

      const cleanTitle = file.name
        .replace(/\.[^/.]+$/, "")
        .replace(/[_-]/g, " ");

      uploadBulkFile(tempId, file);

      return {
        id: tempId,
        file: file,
        filename: file.name,
        size: (file.size / (1024 * 1024)).toFixed(2) + " MB",
        progress: 0,
        status: "queued",
        error: null,
        s3Key: null,
        uploadUrl: null,
        metadata: {
          episode_number: nextEpNum,
          season_number: 1,
          title: cleanTitle.charAt(0).toUpperCase() + cleanTitle.slice(1),
          description: "",
          coin: 0,
          tags: [],
          sort_order: nextEpNum,
        },
      };
    });

    setBulkEpisodes((prev) => {
      const combined = [...prev, ...newEpisodes];
      if (!selectedEpisodeId && combined.length > 0) {
        setSelectedEpisodeId(combined[0].id);
      }
      return combined;
    });

    e.target.value = "";
  };

  const validateBatch = () => {
    const errors = {};
    const usedEpNumbers = new Set();

    bulkEpisodes.forEach((ep) => {
      const epErrors = {};
      const epNum = parseInt(ep.metadata.episode_number);

      if (isNaN(epNum) || epNum <= 0) {
        epErrors.episode_number = "Episode number must be a positive integer";
      } else {
        if (usedEpNumbers.has(epNum)) {
          epErrors.episode_number = "Duplicate episode number in batch";
        }
        if (
          existingEpisodes.some((ex) => parseInt(ex.episode_number) === epNum)
        ) {
          epErrors.episode_number = "Episode number already exists in series";
        }
        usedEpNumbers.add(epNum);
      }

      if (!ep.metadata.title?.trim()) {
        epErrors.title = "Title is required";
      }

      if (ep.status === "failed") {
        epErrors.upload = "File upload failed";
      } else if (ep.status !== "completed") {
        epErrors.upload = "Upload in progress";
      }

      if (Object.keys(epErrors).length > 0) {
        errors[ep.id] = epErrors;
      }
    });

    return errors;
  };

  const submitBulkEpisodes = async () => {
    const validationErrors = validateBatch();
    if (Object.keys(validationErrors).length > 0) {
      setBulkErrors(validationErrors);
      toast.error("Please resolve validation errors before saving.");
      return;
    }

    const pendingUploads = bulkEpisodes.filter(
      (ep) => ep.status !== "completed",
    );
    if (pendingUploads.length > 0) {
      toast.error("Please wait for all uploads to complete.");
      return;
    }

    setBulkSubmitting(true);

    try {
      const payload = {
        series_id: parseInt(id),
        episodes: bulkEpisodes.map((ep) => ({
          episode_number: parseInt(ep.metadata.episode_number),
          s3_key: ep.s3Key,
          title: ep.metadata.title.trim(),
          description: ep.metadata.description?.trim() || null,
          tags:
            ep.metadata.tags && ep.metadata.tags.length > 0
              ? ep.metadata.tags.join(",")
              : null,
          coin:
            ep.metadata.coin !== "" && ep.metadata.coin != null
              ? parseInt(ep.metadata.coin)
              : 0,
          season_number:
            ep.metadata.season_number !== "" &&
            ep.metadata.season_number != null
              ? parseInt(ep.metadata.season_number)
              : 1,
          sort_order:
            ep.metadata.sort_order !== "" && ep.metadata.sort_order != null
              ? parseInt(ep.metadata.sort_order)
              : parseInt(ep.metadata.episode_number),
        })),
      };

      // Single and bulk share one endpoint now — this is the same call the
      // single-episode form makes, with more than one entry in `episodes`.
      const response = await Authservices.addEpisodes(payload);
      const resData = response?.data || response;
      if (resData?.status || resData?.success) {
        setShowBulkModel(false);
        setIsBulkMinimized(false);
        setBulkEpisodes([]);
        setBulkErrors({});
        $("body").removeClass("no_scroll");
        $(".overlay").removeClass("qv_active");

        if (dataTableInstanceRef.current) {
          dataTableInstanceRef.current.ajax.reload(null, false);
        }

        // Bulk transcodes can take a while across many episodes, so we don't
        // poll for this path — just point the admin at revisiting the list.
        Swal.fire({
          icon: "success",
          title: "Episodes uploaded!",
          text:
            resData.message ||
            `${bulkEpisodes.length} episode(s) uploaded. Transcoding is running in the background and can take a few minutes per episode — please revisit this page shortly to check each episode's status.`,
          confirmButtonText: "Okay",
        });
      } else {
        toast.error(resData?.message || "Bulk creation failed.");
      }
    } catch (err) {
      console.error("[Bulk Add API Error]:", err);
      const errMsg =
        err?.response?.data?.message ||
        err?.message ||
        "An error occurred during bulk creation.";
      toast.error(errMsg, { autoClose: 8000 });
    } finally {
      setBulkSubmitting(false);
    }
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      const hasActiveUploads = bulkEpisodes.some(
        (ep) => ep.status === "uploading" || ep.status === "presigning",
      );
      if (hasActiveUploads) {
        e.preventDefault();
        e.returnValue =
          "Uploads are in progress. Are you sure you want to leave?";
        return e.returnValue;
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [bulkEpisodes]);

  useEffect(() => {
    if (bulkEpisodes.length === 0) {
      allBulkFilesUploadedRef.current = false;
      return;
    }
    const allDone = bulkEpisodes.every(
      (ep) => ep.status === "completed" || ep.status === "failed",
    );
    // Toasts render globally, so this fires whether the widget is minimized
    // or expanded — the per-file checkmarks in the list are only visible
    // when expanded.
    if (allDone && !allBulkFilesUploadedRef.current) {
      const hasFailed = bulkEpisodes.some((ep) => ep.status === "failed");
      if (hasFailed) {
        toast.warn("Some files failed to upload. Review before saving.", {
          autoClose: 6000,
        });
      } else {
        toast.success(
          `All ${bulkEpisodes.length} file(s) uploaded successfully!`,
        );
      }
    }
    allBulkFilesUploadedRef.current = allDone;
  }, [bulkEpisodes]);

  useEffect(() => {
    let tableRefCurrent = tableRef.current;
    const $ = window.$ || window.jQuery;

    let currentSize = window.innerWidth <= 450 ? "mobile" : "desktop";

    function setPaginationOptions() {
      if (currentSize === "mobile") {
        $.fn.dataTable.ext.pager.numbers_length = 0;
        return "simple";
      } else {
        $.fn.dataTable.ext.pager.numbers_length = 5;
        return "simple_numbers";
      }
    }

    const initDataTable = () => {
      const pagingType = setPaginationOptions();

      if (
        $ &&
        tableRefCurrent &&
        !$.fn.DataTable.isDataTable(tableRefCurrent)
      ) {
        dataTableInstanceRef.current = $(tableRefCurrent).DataTable({
          processing: true,
          serverSide: false,
          scrollX: true,
          autoWidth: false,
          scrollCollapse: true,
          pagingType: pagingType,
          ajax: (dataTablesParams, callback) => {
            const params = {
              search: "",
              page: 1,
              limit: 500,
              series_id: parseInt(id),
            };
            dispatch(action.getEpisodes(params))
              .then((actionResult) => {
                const rd = actionResult.responseDetails;
                const rows =
                  rd?.data || rd?.rows || (Array.isArray(rd) ? rd : []);
                const total =
                  rd?.totalRecords || rd?.recordsTotal || rows.length;
                setCount(total);
                setExistingEpisodes(rows);
                const maxEpNum = rows.reduce((max, r) => {
                  const num = parseInt(r.episode_number);
                  return !isNaN(num) && num > max ? num : max;
                }, 0);
                setMaxEpisodeNumber(maxEpNum);
                callback({
                  draw: dataTablesParams.draw,
                  data: rows,
                  recordsTotal: total,
                  recordsFiltered: total,
                });
              })
              .catch((err) => {
                console.error("Episodes list error:", err);
                callback({
                  draw: dataTablesParams.draw,
                  data: [],
                  recordsTotal: 0,
                  recordsFiltered: 0,
                });
              });
          },
          destroy: true,
          order: [2, "asc"],
          columns: [
            {
              data: null,
              title: "No",
              width: "25px",
              orderable: false,
              render: function (data, type, row, meta) {
                return meta.row + meta.settings._iDisplayStart + 1;
              },
            },
            {
              data: null,
              width: "100px",
              title: "Thumbnail",
              orderable: false,
              render: function (data, type, row) {
                const thumb = row.thumbnail_url || row.thumbnail || "";
                if (!thumb)
                  return '<div class="img-wrapper" style="display:flex;align-items:center;justify-content:center;background:#1a1a2e;height:48px;border-radius:4px"><i class="fas fa-film" style="color:#666;font-size:18px"></i></div>';
                return `<div class="img-wrapper"><img src="${thumb}" onerror="this.parentElement.innerHTML='<i class=\\'fas fa-film\\' style=\\'color:#666;font-size:18px\\'></i>'" /></div>`;
              },
            },
            { data: "episode_number", title: "Episode No.", width: "100px" },
            {
              data: "title",
              title: "Title",
              width: "200px",
              defaultContent: "-",
            },
            {
              data: "created_at",
              title: "Date",
              orderable: true,
              width: "150px",
              render: function (data, type, row) {
                if (!data) return "";
                return moment(data).format("MMMM DD, YYYY");
              },
            },
            {
              data: "transcoding_status",
              title: "Status",
              orderable: false,
              width: "110px",
              render: function (data, type, row) {
                if (data === "complete")
                  return `<span class="badge bg-success" data-status-id="${row.id}">Complete</span>`;
                if (data === "failed") {
                  // Hover shows why it failed, straight from transcoding_error.
                  const reason = escapeHtml(row.transcoding_error || "");
                  const titleAttr = reason ? ` title="${reason}"` : "";
                  return `<span class="badge bg-danger" data-status-id="${row.id}"${titleAttr}>Failed</span>`;
                }
                if (data === "processing")
                  return `<span class="badge bg-warning text-dark" data-status-id="${row.id}">Processing</span>`;
                if (data === "queued" || data === "pending")
                  return `<span class="badge bg-secondary" data-status-id="${row.id}">Queued</span>`;
                return `<span class="badge bg-secondary" data-status-id="${row.id}">-</span>`;
              },
            },
            {
              data: null,
              title: "Action",
              orderable: false,
              width: "150px",
              render: function (data, type, row) {
                const resolvedHls = resolveHlsUrl(row.hls_url);
                const rawUrl = row.raw_video_url || row.video_url || "";
                const videoUrl = resolvedHls || rawUrl;
                const canPreview = row.transcoding_status === "complete";
                const previewBtn = canPreview
                  ? `<button class="btn btn-sm btn-primary video-prv-btn" data-video="${videoUrl}" data-raw="${rawUrl}" data-episode-id="${row.id}" title="Preview"><i class="fas fa-eye"></i></button>`
                  : `<button class="btn btn-sm btn-secondary" disabled title="Preview unavailable"><i class="fas fa-eye"></i></button>`;
                // Retry only applies to a stopped transcode. The API rejects a retry
                // while the episode is still queued or processing.
                const retryBtn =
                  row.transcoding_status === "failed"
                    ? `<button class="btn btn-sm btn-warning retry-btn" data-episode-id="${row.id}" title="Retry transcoding"><i class="fas fa-redo"></i></button>`
                    : "";
                return `
                                                                        <div class="d-flex gap-2">
                                                                                ${previewBtn}
                                                                                ${retryBtn}
                                                                                <button class="btn btn-sm btn-primary edit-btn" title="Edit">
                                                                                        <i class="fas fa-edit"></i>
                                                                                </button>
                                                                                <button class="btn btn-sm btn-danger delete-btn" title="Delete">
                                                                                        <i class="fas fa-trash-alt"></i>
                                                                                </button>
                                                                        </div>
                                                                `;
              },
            },
          ],
        });

        $(tableRefCurrent).on("preXhr.dt", function () {
          const processingEl = $(".dataTables_processing");
          const visibleCols =
            $(tableRefCurrent).find("thead th:visible").length;

          if (processingEl.length) {
            const loaderRow = `
                                                        <tr class="dt-temp-loader">
                                                                <td colspan="${visibleCols}" class="text-center">
                                                                        <div class="dataTables_processing card" style="display:block;margin:0 auto">${processingEl.html()}</div>
                                                                </td>
                                                        </tr>
                                                `;
            $(tableRefCurrent).find("tbody").html(loaderRow);
          }
        });

        $(tableRefCurrent).on("xhr.dt", function () {
          $(tableRefCurrent).find("tbody .dt-temp-loader").remove();
        });

        $(tableRefCurrent).on("click", ".video-prv-btn", function (e) {
          const fallbackHls = $(this).data("video");
          const rawSrc = $(this).data("raw") || "";
          const episodeId = $(this).data("episode-id");
          console.log(
            "[Episodes] Preview click → episodeId:",
            episodeId,
            "| fallbackHls:",
            fallbackHls,
          );
          if (!fallbackHls && !rawSrc) {
            toast.warn(
              "No video available. Transcoding may have failed or the video URL is not yet set.",
            );
            return;
          }
          if (!episodeId) {
            handleVideoPreview(fallbackHls, rawSrc);
            return;
          }
          Authservices.getEpisodeStreamUrl(episodeId)
            .then((res) => {
              const details = res?.data?.responseDetails;
              if (!details) {
                toast.warn("No stream details in response.");
                return;
              }
              const videoType = details.videoType || "";
              if (
                videoType === "hls-signed-cookies" &&
                details.cookies &&
                details.videoUrl
              ) {
                const cfOrigin = (() => {
                  try {
                    return new URL(details.videoUrl).origin;
                  } catch (_) {
                    return null;
                  }
                })();
                const creds = {
                  policy: details.cookies["CloudFront-Policy"],
                  signature: details.cookies["CloudFront-Signature"],
                  keyPairId: details.cookies["CloudFront-Key-Pair-Id"],
                  cfOrigin,
                };
                cfCredentialsRef.current = creds;
                bunnyQsRef.current = null;
                const qs = `Policy=${encodeURIComponent(creds.policy)}&Signature=${encodeURIComponent(creds.signature)}&Key-Pair-Id=${encodeURIComponent(creds.keyPairId)}`;
                const signedMasterUrl = details.videoUrl.includes("?")
                  ? `${details.videoUrl}&${qs}`
                  : `${details.videoUrl}?${qs}`;
                console.log(
                  "[Episodes] Signed cookies → using custom-policy signed URL:",
                  signedMasterUrl.slice(0, 100) + "...",
                );
                handleVideoPreview(signedMasterUrl, rawSrc);
              } else {
                const signedUrl =
                  details.signed_url || details.url || details.videoUrl;
                cfCredentialsRef.current = null;
                bunnyQsRef.current =
                  videoType === "hls-bunny-token" && signedUrl?.includes("?")
                    ? signedUrl.split("?")[1]
                    : null;
                if (signedUrl) {
                  console.log(
                    "[Episodes] Got signed URL:",
                    signedUrl.slice(0, 100) + "...",
                  );
                  handleVideoPreview(signedUrl, rawSrc);
                } else {
                  toast.warn("No playable URL found in stream response.");
                }
              }
            })
            .catch((err) => {
              const status = err?.response?.status;
              const errBody = err?.response?.data;
              console.error(
                "[Episodes] stream-url error — status:",
                status,
                "| body:",
                JSON.stringify(errBody),
              );
              if (status === 404) {
                toast.info(
                  "Stream URL endpoint not found on server. Contact your backend developer.",
                  { autoClose: 8000 },
                );
              } else if (status === 500) {
                toast.error(
                  "Episode preview unavailable — the stream URL service failed. The video may still be transcoding or the backend stream service has an error. Contact your backend developer.",
                  { autoClose: 10000 },
                );
              } else {
                toast.error(
                  `Stream URL error (${status}): ${errBody?.responseMessage || errBody?.message || "Unknown error"}`,
                  { autoClose: 8000 },
                );
              }
            });
        });

        $(tableRefCurrent).on("click", ".edit-btn", function (e) {
          let rowData = dataTableInstanceRef.current
            .row($(this).closest("tr"))
            .data();
          openModel("Edit");
          const rawTags = isEmpty(rowData.tags)
            ? []
            : rowData.tags
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean);
          const numericTags = rawTags.map(Number).filter((n) => !isNaN(n));
          const resolvedTags =
            numericTags.length === rawTags.length
              ? numericTags
              : rawTags
                  .map((name) => tagList.find((t) => t.label === name)?.value)
                  .filter((n) => n != null);
          setEpisodeData({
            id: rowData.id,
            series_id: id,
            episode_number: rowData.episode_number,
            coin: rowData.coin,
            title: rowData?.title || "",
            description: rowData?.description || "",
            tags: resolvedTags,
          });
          setFilePreview(rowData.thumbnail_url || rowData.video_url || "");
        });

        $(tableRefCurrent).off("click", ".retry-btn");
        $(tableRefCurrent).on("click", ".retry-btn", function (e) {
          e.preventDefault();
          if (!canEdit("series")) {
            toast.error("You don't have permission to edit episodes.");
            return false;
          }
          const episodeId = $(this).data("episode-id");
          const btn = $(this);
          btn.prop("disabled", true);
          dispatch(action.retryEpisodeTranscode(episodeId))
            .then(() => {
              toast.info(`Episode #${episodeId} re-queued for transcoding.`);
              paintStatusBadge(episodeId, "queued");
              startBulkPollingRef.current?.([episodeId]);
              if (dataTableInstanceRef.current) {
                dataTableInstanceRef.current.ajax.reload(null, false);
              }
            })
            .catch((error) => {
              btn.prop("disabled", false);
              toast.error(
                error?.responseMessage ||
                  error?.message ||
                  "Could not re-queue this episode.",
              );
            });
        });

        $(tableRefCurrent).off("click", ".delete-btn");
        $(tableRefCurrent).on("click", ".delete-btn", function (e) {
          if (!canDelete("series")) {
            toast.error("You don't have permission to delete episodes.");
            return false;
          }

          let rowData = dataTableInstanceRef.current
            .row($(this).closest("tr"))
            .data();
          Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "var(--first-color)",
            cancelButtonColor: "var(--error-color)",
            confirmButtonText: "Yes, delete it!",
            customClass: {
              confirmButton: "btn",
              cancelButton: "btn",
            },
          }).then((result) => {
            if (result.isConfirmed) {
              dispatch(action.deleteEpisodes({ id: rowData.id }))
                .then((action) => {
                  Swal.fire({
                    title: "Deleted!",
                    text: "Your data has been deleted.",
                    icon: "success",
                    customClass: {
                      confirmButton: "btn",
                    },
                  });
                  if (dataTableInstanceRef.current) {
                    dataTableInstanceRef.current.ajax.reload(null, false);
                  }
                })
                .catch((err) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    customClass: {
                      confirmButton: "btn",
                    },
                  });
                });
            }
          });
        });
      }
    };

    initDataTable();

    const handleResize = () => {
      const newSize = window.innerWidth <= 450 ? "mobile" : "desktop";
      if (newSize !== currentSize) {
        currentSize = newSize;

        // Destroy and re-init
        if ($.fn.DataTable.isDataTable(tableRefCurrent)) {
          $(tableRefCurrent).DataTable().destroy();
        }
        initDataTable();
      }
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      if ($.fn.DataTable.isDataTable(tableRefCurrent)) {
        $(tableRefCurrent).DataTable().destroy();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id, user]);

  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;

    const getData = () => {
      dispatch(getTags({ getAll: true }))
        .then((action) => {
          let data = action.responseDetails.data || [];
          setTagList(data.map((x) => ({ value: x.id, label: x.name })));
        })
        .catch(() => {
          setTagList([]);
        });
    };

    getData();
  }, [dispatch]);

  useEffect(() => {
    let cancelled = false;
    dispatch(getSeriesDetails({ series_id: Number(id) }))
      .then((response) => {
        if (cancelled) return;
        const details = response.responseDetails || {};
        setSeriesTitle(details.title || "");
        setSeriesInfo(details);
      })
      .catch(() => {
        if (!cancelled) toast.error("Could not refresh series details. Please reload the page.");
      });
    return () => { cancelled = true; };
  }, [dispatch, id, seriesRevision]);

  const handleVideoPreview = (videoSrc, rawSrc = "") => {
    rawVideoUrlRef.current = rawSrc;
    setCurrentVideoSrc(videoSrc);
    setVideoPopupVisible(true);
  };

  const handlePreviewEditVideo = () => {
    const epId = episodeData.id;
    if (!epId) return;
    Authservices.getEpisodeStreamUrl(epId)
      .then((res) => {
        const details = res?.data?.responseDetails;
        if (!details) {
          toast.warn("No stream details available.");
          return;
        }
        const videoType = details.videoType || "";
        if (
          videoType === "hls-signed-cookies" &&
          details.cookies &&
          details.videoUrl
        ) {
          const creds = {
            policy: details.cookies["CloudFront-Policy"],
            signature: details.cookies["CloudFront-Signature"],
            keyPairId: details.cookies["CloudFront-Key-Pair-Id"],
          };
          cfCredentialsRef.current = creds;
          bunnyQsRef.current = null;
          const qs = `Policy=${encodeURIComponent(creds.policy)}&Signature=${encodeURIComponent(creds.signature)}&Key-Pair-Id=${encodeURIComponent(creds.keyPairId)}`;
          const signedUrl = details.videoUrl.includes("?")
            ? `${details.videoUrl}&${qs}`
            : `${details.videoUrl}?${qs}`;
          handleVideoPreview(signedUrl, "");
        } else {
          const url = details.signed_url || details.url || details.videoUrl;
          cfCredentialsRef.current = null;
          bunnyQsRef.current =
            videoType === "hls-bunny-token" && url?.includes("?")
              ? url.split("?")[1]
              : null;
          if (url) handleVideoPreview(url, "");
          else toast.warn("No playable URL found.");
        }
      })
      .catch((err) => {
        const status = err?.response?.status;
        if (status === 404)
          toast.info("Stream URL endpoint not found on server.", {
            autoClose: 8000,
          });
        else
          toast.error("Could not load video preview. Please try again.", {
            autoClose: 6000,
          });
      });
  };

  const handleClosePopup = () => {
    if (hlsRef.current) {
      hlsRef.current.destroy();
      hlsRef.current = null;
    }
    setVideoPopupVisible(false);
    setCurrentVideoSrc("");
    setHlsLevels([]);
    setCurrentQualityIdx(-1);
    setShowQualityMenu(false);
  };

  const handlePopupBackgroundClick = (e) => {
    if (e.target.classList.contains("video-popup")) {
      handleClosePopup();
    }
  };

  useEffect(() => {
    if (!videoPopupVisible || !currentVideoSrc || !videoRef.current) return;
    const video = videoRef.current;
    const isHls = currentVideoSrc.includes(".m3u8");
    let hlsInstance = null;

    const tryMp4Fallback = (fallbackSrc) => {
      if (fallbackSrc && !fallbackSrc.includes(".m3u8")) {
        video.src = fallbackSrc;
        video.play().catch(() => {});
      } else {
        toast.error(
          "Video could not be loaded. The file may still be processing.",
        );
      }
    };

    if (isHls && Hls.isSupported()) {
      video.crossOrigin = "anonymous";
      const creds = cfCredentialsRef.current;
      const bunnyQs = bunnyQsRef.current;
      const hls = new Hls({
        startLevel: -1,
        enableWorker: true,
        xhrSetup: (xhr, url) => {
          xhr.withCredentials = false;
          if (creds && url && !url.includes("Policy=")) {
            let targetUrl = url;
            if (creds.cfOrigin) {
              try {
                const parsed = new URL(url);
                if (parsed.origin !== creds.cfOrigin) {
                  targetUrl =
                    creds.cfOrigin +
                    parsed.pathname +
                    parsed.search +
                    parsed.hash;
                }
              } catch (_) {}
            }
            const sep = targetUrl.includes("?") ? "&" : "?";
            const signedUrl = `${targetUrl}${sep}Policy=${encodeURIComponent(creds.policy)}&Signature=${encodeURIComponent(creds.signature)}&Key-Pair-Id=${encodeURIComponent(creds.keyPairId)}`;
            xhr.open("GET", signedUrl, true);
          } else if (bunnyQs && url && !url.includes("token=")) {
            const sep = url.includes("?") ? "&" : "?";
            const signedUrl = `${url}${sep}${bunnyQs}`;
            xhr.open("GET", signedUrl, true);
          }
        },
      });
      hlsInstance = hls;
      hlsRef.current = hls;
      hls.loadSource(currentVideoSrc);
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        const levels = hls.levels.map((l, i) => ({
          idx: i,
          height: l.height,
          label: `${l.height}p`,
        }));
        setHlsLevels(levels);
        setCurrentQualityIdx(-1);
        video.play().catch(() => {});
      });
      hls.on(Hls.Events.LEVEL_SWITCHED, (_, data) => {
        setCurrentQualityIdx((prev) => (prev === -1 ? -1 : data.level));
      });
      hls.on(Hls.Events.ERROR, (_, data) => {
        if (data.fatal) {
          console.error(
            "[HLS] Fatal error:",
            data.type,
            data.details,
            currentVideoSrc,
          );
          hls.destroy();
          if (hlsRef.current === hls) {
            hlsRef.current = null;
          }
          const isSignedUrl =
            currentVideoSrc.includes("Signature=") ||
            currentVideoSrc.includes("Key-Pair-Id=");
          if (data.details === "manifestLoadError" && isSignedUrl) {
            console.error(
              "[HLS] CloudFront CORS fix required: Add Response Headers Policy to CloudFront distribution with Access-Control-Allow-Origin: * and Access-Control-Allow-Methods: GET, HEAD",
            );
            // Try raw video fallback before showing error
            if (rawVideoUrlRef.current) {
              console.log(
                "[HLS] Falling back to raw video:",
                rawVideoUrlRef.current,
              );
              tryMp4Fallback(rawVideoUrlRef.current);
            } else {
              toast.error(
                "Video cannot be played due to a CORS configuration issue on the video CDN. Please contact your backend developer to add CORS headers to the CloudFront distribution.",
                { autoClose: 12000 },
              );
            }
          } else {
            tryMp4Fallback(rawVideoUrlRef.current);
          }
        }
      });
    } else if (isHls && video.canPlayType("application/vnd.apple.mpegurl")) {
      video.crossOrigin = "anonymous";
      video.src = currentVideoSrc;
      video.play().catch(() => {});
    } else {
      video.src = currentVideoSrc;
      video.play().catch(() => {});
    }
    return () => {
      if (hlsInstance) {
        hlsInstance.destroy();
      }
      if (hlsRef.current === hlsInstance) {
        hlsRef.current = null;
      }
    };
  }, [videoPopupVisible, currentVideoSrc]);

  // Paint one row's status badge in place, so the table doesn't have to be
  // reloaded on every poll tick.
  const paintStatusBadge = (episodeId, status, errorText) => {
    const cell = document.querySelector(`[data-status-id="${episodeId}"]`);
    if (!cell) return;
    if (status === "complete") {
      cell.className = "badge bg-success";
      cell.textContent = "Complete";
      cell.removeAttribute("title");
    } else if (status === "failed") {
      cell.className = "badge bg-danger";
      cell.textContent = "Failed";
      // The reason comes from transcoding_error — show it rather than a bare "Failed".
      if (errorText) cell.setAttribute("title", errorText);
    } else if (status === "processing") {
      cell.className = "badge bg-warning text-dark";
      cell.textContent = "Processing";
    } else if (status === "queued" || status === "pending") {
      cell.className = "badge bg-secondary";
      cell.textContent = "Queued";
    }
  };

  // One poller for one or many episodes — the status endpoint takes a list, and a
  // single episode is a list of one.
  const startBulkTranscodingPoll = useCallback(
    (episodeIds) => {
      if (!episodeIds || episodeIds.length === 0) return;
      const numericIds = episodeIds.map(Number).filter(id => !isNaN(id));
      if (numericIds.length === 0) return;

      const pollKey = numericIds.sort((a, b) => a - b).join(",");
      if (pollingRef.current[pollKey]) return;

      const interval = setInterval(() => {
        dispatch(action.getTranscodingStatus({ episode_ids: numericIds }))
          .then((res) => {
            const resData = res?.data || res?.responseDetails || res;
            const episodes = resData?.episodes || [];

            episodes.forEach((ep) => {
              paintStatusBadge(ep.episode_id, ep.transcoding_status, ep.error);
            });

            // Stop only when nothing is left in flight. Counting on `summary`
            // alone missed 'queued' and ended the poll before work had started.
            const stillRunning = episodes.some((ep) =>
              IN_FLIGHT_STATUSES.includes(ep.transcoding_status),
            );
            if (stillRunning) return;

            clearInterval(pollingRef.current[pollKey]);
            delete pollingRef.current[pollKey];

            const failed = episodes.filter(
              (ep) => ep.transcoding_status === "failed",
            );
            if (failed.length === 0) {
              toast.success(
                episodes.length === 1
                  ? "Transcoding complete!"
                  : "Bulk transcoding completed!",
              );
            } else {
              toast.error(
                `${failed.length} of ${episodes.length} episode(s) failed to transcode. ${failed[0].error || ""}`.trim(),
                { autoClose: 8000 },
              );
            }
            if (dataTableInstanceRef.current) {
              dataTableInstanceRef.current.ajax.reload(null, false);
            }
          })
          .catch((err) => {
            console.error("Transcoding poll error:", err);
          });
      }, 60000);
      pollingRef.current[pollKey] = interval;
    },
    [dispatch],
  );

  const startTranscodingPoll = useCallback(
    (episodeId) => startBulkTranscodingPoll([episodeId]),
    [startBulkTranscodingPoll],
  );

  startPollingRef.current = startTranscodingPoll;
  startBulkPollingRef.current = startBulkTranscodingPoll;

  useEffect(() => {
    const polls = pollingRef.current;
    return () => {
      Object.values(polls).forEach(clearInterval);
    };
  }, []);


  const openModel = (name) => {
    setShowModel({
      show: true,
      title: name,
    });
    $("body").addClass("no_scroll");
    $(".overlay").addClass("qv_active");
  };

  const closeModel = (name) => {
    isSubmittingRef.current = false;
    setShowModel({
      show: false,
      title: name,
    });
    $("body").removeClass("no_scroll");
    $(".overlay").removeClass("qv_active");
    setErrors({});
    setUploadProgress(null);
    setIsUploading(false);
    setUploadStatus("");
    setEpisodeData({
      id: 0,
      series_id: id,
      episode_number: "",
      coin: 0,
      video_url: "",
      title: "",
      description: "",
      tags: [],
    });
    setFilePreview("");
  };

  const handleAddField = () => {
    setUrlFields([...urlFields, ""]);
  };

  const handleRemoveField = (index) => {
    const updated = [...urlFields];
    updated.splice(index, 1);
    setUrlFields(updated);
  };

  const handleChange = (index, value) => {
    const updated = [...urlFields];
    updated[index] = value;
    setUrlFields(updated);
  };

  // eslint-disable-next-line no-unused-vars
  const openUrlModel = () => {
    setUrlModel(true);
    $("body").addClass("no_scroll");
    $(".overlay").addClass("qv_active");
  };

  const closeUrlModel = () => {
    setUrlModel(false);
    $("body").removeClass("no_scroll");
    $(".overlay").removeClass("qv_active");
    setErrors({});
    setUrlFields([""]);
  };

  const onChange = (e) => {
    setEpisodeData({ ...episodeData, [e.target.name]: e.target.value });
  };

  const onChangeSelect2 = (value) => {
    setEpisodeData((prevData) => ({ ...prevData, tags: value }));
  };

  const handleImage = (e, image, preview) => {
    setEpisodeData({ ...episodeData, [e.target.name]: image });
    setFilePreview(preview);
  };

  const generateVideoThumbnail = (videoFile, seekTime = 2) => {
    return new Promise((resolve) => {
      const video = document.createElement("video");
      video.preload = "metadata";
      video.muted = true;
      video.playsInline = true;
      video.crossOrigin = "anonymous";
      const objectUrl = URL.createObjectURL(videoFile);
      video.src = objectUrl;

      const cleanup = () => {
        try {
          URL.revokeObjectURL(objectUrl);
        } catch (_) {}
      };

      const captureFrame = () => {
        try {
          const w = video.videoWidth || 640;
          const h = video.videoHeight || 360;
          const canvas = document.createElement("canvas");
          canvas.width = w;
          canvas.height = h;
          canvas.getContext("2d").drawImage(video, 0, 0, w, h);
          canvas.toBlob(
            (blob) => {
              cleanup();
              resolve(blob || null);
            },
            "image/jpeg",
            0.82,
          );
        } catch (_) {
          cleanup();
          resolve(null);
        }
      };

      video.addEventListener("seeked", captureFrame, { once: true });
      video.addEventListener(
        "error",
        () => {
          cleanup();
          resolve(null);
        },
        { once: true },
      );

      video.addEventListener(
        "loadedmetadata",
        () => {
          const target = Math.min(
            seekTime,
            (video.duration || seekTime) * 0.1 + 0.5,
          );
          video.currentTime = target;
        },
        { once: true },
      );

      setTimeout(() => {
        cleanup();
        resolve(null);
      }, 12000);
    });
  };

  const addEpisodesData = async (e) => {
    e.preventDefault();
    if (isSubmittingRef.current) return;

    const isEdit = episodeData.id !== 0;
    if (isEdit ? !canEdit("series") : !canCreate("series")) {
      toast.error(
        `You don't have permission to ${isEdit ? "edit" : "upload"} episodes.`,
      );
      return;
    }

    setErrors({});
    let customErrors = {};

    if (
      episodeData.episode_number === "" ||
      episodeData.episode_number == null
    ) {
      customErrors.episode_number = "Please enter an episode number";
    }
    if (!episodeData.title?.trim()) {
      customErrors.title = "Please enter a title";
    }
    if (!isEdit && !episodeData.video_url) {
      customErrors.video_url = "Please select a video";
    }

    if (Object.keys(customErrors).length > 0) {
      setErrors(customErrors);
      if (customErrors.episode_number) episodeNumberRefFocus.current?.focus();
      else if (customErrors.title) titleRefFocus.current?.focus();
      return;
    }

    isSubmittingRef.current = true;

    const isEditingEpisode = episodeData.id !== 0;
    const hasNewVideo = episodeData.video_url instanceof File;

    try {
      let s3Key = null;

      if (hasNewVideo) {
        const file = episodeData.video_url;

        // Step 1 — get pre-signed S3 URL (goes through /api-proxy/ with auth)
        setIsUploading(true);
        setUploadStatus("Uploading video to S3...");
        setUploadProgress(0);
        let presignedRes;
        try {
          presignedRes = await Authservices.getEpisodePresignedUrl({
            filename: file.name,
            content_type: file.type,
          });
        } catch (err) {
          const serverMsg =
            err?.response?.data?.responseMessage ||
            err?.response?.data?.message ||
            err?.message;
          throw new Error(
            `Could not get upload URL from server${serverMsg ? ": " + serverMsg : ". Please contact support."}`,
          );
        }

        const { upload_url, s3_key } = presignedRes.data.data;
        s3Key = s3_key;

        // Step 2 — upload directly to S3 via the presigned URL (no size limit)
        try {
          await s3Axios.put(upload_url, file, {
            headers: { "Content-Type": file.type },
            onUploadProgress: (e) => {
              const percent = Math.round((e.loaded * 100) / e.total);
              setUploadProgress(percent);
            },
          });
        } catch (err) {
          const status = err?.response?.status;
          console.error("[S3 Upload] Direct PUT failed:", status, err?.message);
          throw new Error(
            `S3 upload failed (${status || "network error"}). Please try again or contact support.`,
          );
        }

        setIsUploading(false);
        setUploadProgress(null);
      }

      // Step 2b — generate thumbnail client-side and upload to S3
      let thumbnailUrl = null;
      let rawVideoCdnUrl = null;

      if (hasNewVideo && s3Key) {
        // Construct raw CDN video URL from s3_key so preview works before transcoding
        rawVideoCdnUrl = `${CDN_BASE}/${s3Key.replace(/^\//, "")}`;

        try {
          setIsUploading(true);
          setUploadStatus("Generating thumbnail...");
          setUploadProgress(null);
          const thumbBlob = await generateVideoThumbnail(episodeData.video_url);
          if (thumbBlob) {
            const thumbFilename = `thumb_ep_${Date.now()}.jpg`;
            // Use episode presigned URL endpoint for the thumbnail image
            const thumbPresignedRes = await Authservices.getEpisodePresignedUrl(
              {
                filename: thumbFilename,
                content_type: "image/jpeg",
              },
            );
            const thumbData =
              thumbPresignedRes?.data?.data ||
              thumbPresignedRes?.data?.responseDetails ||
              thumbPresignedRes?.data;
            const thumbUploadUrl = thumbData?.upload_url;
            const thumbKey = thumbData?.s3_key;
            console.log(
              "[Thumbnail] Presigned response:",
              JSON.stringify(thumbPresignedRes?.data),
            );
            if (thumbUploadUrl && thumbKey) {
              setUploadStatus("Uploading thumbnail...");
              await s3Axios.put(thumbUploadUrl, thumbBlob, {
                headers: { "Content-Type": "image/jpeg" },
              });
              thumbnailUrl = `${CDN_BASE}/${thumbKey.replace(/^\//, "")}`;
              console.log("[Thumbnail] Generated and uploaded:", thumbnailUrl);
            } else {
              console.warn(
                "[Thumbnail] Presigned URL missing upload_url or s3_key:",
                thumbData,
              );
            }
          }
        } catch (thumbErr) {
          console.warn(
            "[Thumbnail] Auto-generation skipped:",
            thumbErr.message,
          );
        }
        setIsUploading(false);
        setUploadProgress(null);
        setUploadStatus("");
      }

      // Step 3 — build separate payloads for add vs update.
      // UPDATE: identified by id only — do NOT send series_id (causes unique constraint
      // collision) or raw_video_url (not a DB column; causes Sequelize 500).
      // ADD: series_id required so backend knows which series to attach the episode to.
      const commonFields = {
        episode_number: episodeData.episode_number,
        coin:
          episodeData.coin !== "" && episodeData.coin != null
            ? Number(episodeData.coin)
            : 0,
        ...(episodeData.title?.trim() && { title: episodeData.title.trim() }),
        description: (episodeData.description || "").trim(),
        ...(episodeData.tags.length > 0 && {
          tags: episodeData.tags.filter((n) => !isNaN(n)).join(","),
        }),
        ...(s3Key && { s3_key: s3Key }),
        ...(thumbnailUrl && { thumbnail_url: thumbnailUrl }),
      };

      if (isEditingEpisode) {
        const updatePayload = {
          id: episodeData.id,
          series_id: Number(episodeData.series_id),
          ...commonFields,
          // Send current CDN url so backend can preview pre-transcoding video;
          // backend should overwrite with HLS url after transcoding completes.
          ...(rawVideoCdnUrl && { video_url: rawVideoCdnUrl }),
        };
        console.log("[Episode Update] Payload:", JSON.stringify(updatePayload));
        dispatch(action.updateEpisodes(updatePayload))
          .then((response) => {
            isSubmittingRef.current = false;
            const msg =
              response.responseMessage ||
              response.message ||
              "Episode updated!";
            toast.success(msg);
            closeModel("Add");
            if (dataTableInstanceRef.current)
              dataTableInstanceRef.current.ajax.reload(null, false);
            const updatedData = response.responseDetails || response.data || {};
            if (updatedData.transcoding_status === "processing") {
              const epId = updatedData.id || episodeData.id;
              toast.info("Video replaced — transcoding started.", {
                autoClose: 5000,
              });
              startTranscodingPoll(epId);
            }
          })
          .catch((error) => {
            isSubmittingRef.current = false;
            const errMsg =
              error?.responseMessage ||
              error?.message ||
              error?.error ||
              error?.errors?.[0] ||
              "Update failed — check browser console for details.";
            console.error(
              "[Episode Update] Error body:",
              JSON.stringify(error),
            );
            toast.error(errMsg, { autoClose: 8000 });
          });
      } else {
        // One episode is a list of one — same endpoint and same body shape the
        // bulk modal uses.
        const addPayload = {
          series_id: episodeData.series_id,
          episodes: [commonFields],
        };
        dispatch(action.addEpisodes(addPayload))
          .then((response) => {
            isSubmittingRef.current = false;
            const msg =
              response.responseMessage ||
              response.message ||
              "Episode uploaded! Transcoding started...";
            toast.success(msg);
            closeModel("Add");
            if (dataTableInstanceRef.current)
              dataTableInstanceRef.current.ajax.reload(null, false);
            // The response is now a list, even for one episode.
            const addedData = response.responseDetails || response.data || [];
            const created = Array.isArray(addedData) ? addedData : [addedData];
            const episodeId = created[0]?.id;
            if (episodeId) {
              toast.info(
                "Transcoding in progress — you'll be notified when complete.",
                { autoClose: 5000 },
              );
              startTranscodingPoll(episodeId);
            }
          })
          .catch((error) => {
            isSubmittingRef.current = false;
            const errMsg =
              error?.responseMessage ||
              error?.message ||
              error?.error ||
              "Upload failed. Please try again.";
            toast.error(errMsg, { autoClose: 8000 });
          });
      }
    } catch (error) {
      isSubmittingRef.current = false;
      setIsUploading(false);
      setUploadProgress(null);
      const msg =
        error?.response?.data?.responseMessage ||
        error?.response?.data?.message ||
        error?.message ||
        "Upload failed. Please try again.";
      toast.error(msg);
    }
  };

  const addEpisodeLinkData = (e) => {
    e.preventDefault();
    if (!canCreate("series")) {
      toast.error("You don't have permission to add episode links.");
      return false;
    }

    setErrors({});
    let customErrors = {};
    urlFields.forEach((url, i) => {
      if (url.trim() === "") {
        customErrors[`url${i}`] = "Please Enter URL";
      }
    });

    if (Object.keys(customErrors).length > 0) {
      setErrors(customErrors);
      return true;
    }

    const finalData = {
      series_id: id,
      episode_links: urlFields.filter((u) => u.trim() !== ""),
    };

    dispatch(action.addEpisodesUrls(finalData))
      .then((response) => {
        toast.success(response.responseMessage);
        closeUrlModel();
        setUrlFields([""]);

        if (dataTableInstanceRef.current) {
          dataTableInstanceRef.current.ajax.reload(null, false);
        }
      })
      .catch((error) => {
        toast.error(
          error?.responseMessage ||
            error?.message ||
            "An error occurred. Please try again.",
        );
      });
  };

  const isUploadComplete =
    bulkEpisodes.length > 0 &&
    bulkEpisodes.every((e) => e.status === "completed" || e.status === "failed");

  return (
    <>
      {/* { loading ? <Loader /> :  */}
      <>
        <div className="overlay"></div>

        {seriesInfo && (
          <SeriesDetailHeader
            key={id}
            series={seriesInfo}
            editButton={<Series editTarget={seriesInfo} onUpdated={() => setSeriesRevision(value => value + 1)} />}
          />
        )}

        <div className="card">
          <div className="card-header">
            <div className="page-title w-100 d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center justify-content-between">
                <h4>
                  Episode List (
                  <span className="total_user">
                    <NumberDisplay count={count} />
                  </span>
                  )
                </h4>
              </div>
              <div className="d-flex align-items-center gap-2">
                {canCreate("series") && (
                  <>
                    <button
                      className="btn upgrade-btn add-notification-btn"
                      onClick={(e) => openModel("Add")}
                    >
                      <i className="fas fa-plus me-1" /> Add Episode
                    </button>
                    <button
                      className="btn upgrade-btn add-notification-btn"
                      style={{
                        background: "linear-gradient(135deg, #10b981, #059669)",
                        border: "none",
                      }}
                      onClick={(e) => {
                        setShowBulkModel(true);
                        setIsBulkMinimized(false);
                        $("body").addClass("no_scroll");
                        $(".overlay").addClass("qv_active");
                      }}
                    >
                      <i className="fas fa-upload me-1" /> Import Episodes from Device
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="card-body">
            <table
              ref={tableRef}
              className="movie-table table-layout-fixed user-table table table-striped w-100 dataTable no-footer"
              id="seriesTables"
              role="grid"
            ></table>
          </div>
        </div>

        {/* Video-popup rendered via portal so it escapes modal stacking context */}
        {videoPopupVisible &&
          ReactDOM.createPortal(
            <div
              className="video-popup"
              style={{ display: "flex" }}
              onClick={(e) => handlePopupBackgroundClick(e)}
            >
              <div
                className="popup-content"
                onClick={(e) => e.stopPropagation()}
              >
                <div
                  className="video-popup-header"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "8px 12px",
                    background: "#0f0f1a",
                    borderBottom: "1px solid rgba(255,255,255,0.08)",
                  }}
                >
                  <span
                    style={{ color: "#ccc", fontSize: "13px", fontWeight: 500 }}
                  >
                    Episode Preview
                  </span>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    {hlsLevels.length > 0 && (
                      <div style={{ position: "relative" }}>
                        <button
                          onClick={() => setShowQualityMenu((m) => !m)}
                          style={{
                            background: "rgba(255,255,255,0.1)",
                            border: "1px solid rgba(255,255,255,0.2)",
                            borderRadius: "4px",
                            color: "#fff",
                            padding: "4px 10px",
                            cursor: "pointer",
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                          title="Quality Settings"
                        >
                          <i
                            className="fas fa-cog"
                            style={{ fontSize: "11px" }}
                          />
                          <span>
                            {currentQualityIdx === -1
                              ? "Auto"
                              : hlsLevels[currentQualityIdx]?.label ||
                                "Quality"}
                          </span>
                        </button>
                        {showQualityMenu && (
                          <div
                            style={{
                              position: "absolute",
                              top: "calc(100% + 4px)",
                              right: 0,
                              background: "#1c1c2e",
                              border: "1px solid rgba(255,255,255,0.15)",
                              borderRadius: "6px",
                              padding: "4px 0",
                              minWidth: "110px",
                              zIndex: 1000,
                              boxShadow: "0 4px 16px rgba(0,0,0,0.5)",
                            }}
                          >
                            <div
                              style={{
                                padding: "4px 8px",
                                color: "#888",
                                fontSize: "11px",
                                letterSpacing: "0.5px",
                                borderBottom:
                                  "1px solid rgba(255,255,255,0.08)",
                                marginBottom: "2px",
                              }}
                            >
                              QUALITY
                            </div>
                            <div
                              onClick={() => {
                                if (hlsRef.current) {
                                  hlsRef.current.currentLevel = -1;
                                }
                                setCurrentQualityIdx(-1);
                                setShowQualityMenu(false);
                              }}
                              style={{
                                padding: "7px 14px",
                                cursor: "pointer",
                                color:
                                  currentQualityIdx === -1 ? "#4fc3f7" : "#ddd",
                                fontSize: "13px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              Auto{" "}
                              {currentQualityIdx === -1 && (
                                <i
                                  className="fas fa-check"
                                  style={{ fontSize: "10px" }}
                                />
                              )}
                            </div>
                            {[...hlsLevels].reverse().map((level) => (
                              <div
                                key={level.idx}
                                onClick={() => {
                                  if (hlsRef.current) {
                                    hlsRef.current.currentLevel = level.idx;
                                  }
                                  setCurrentQualityIdx(level.idx);
                                  setShowQualityMenu(false);
                                }}
                                style={{
                                  padding: "7px 14px",
                                  cursor: "pointer",
                                  color:
                                    currentQualityIdx === level.idx
                                      ? "#4fc3f7"
                                      : "#ddd",
                                  fontSize: "13px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                {level.label}{" "}
                                {currentQualityIdx === level.idx && (
                                  <i
                                    className="fas fa-check"
                                    style={{ fontSize: "10px" }}
                                  />
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                    <button
                      onClick={handleClosePopup}
                      style={{
                        background: "transparent",
                        border: "none",
                        color: "#aaa",
                        cursor: "pointer",
                        padding: "2px 4px",
                        fontSize: "16px",
                        lineHeight: 1,
                      }}
                      title="Close"
                    >
                      &#x2715;
                    </button>
                  </div>
                </div>
                <div className="video-frame-container">
                  <video
                    ref={videoRef}
                    id="showVideoUrl"
                    playsInline
                    controls
                    style={{ width: "100%", display: "block" }}
                  ></video>
                </div>
              </div>
            </div>,
            document.body,
          )}

        {/* edit-popup start here */}
        {showModel.show && (
          <Model className="common-popup edit-popup  active">
            <div className="edit-heading d-flex align-items-center justify-content-between">
              <h3>{showModel.title} Episode</h3>
              <button
                className="common-close edit-close-btn"
                onClick={(e) => closeModel("Edit")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="18"
                  viewBox="0 0 20 18"
                >
                  <path
                    fill="#ffffff"
                    d="M19.95 16.75l-.05-.4-1.2-1-5.2-4.2c-.1-.05-.3-.2-.6-.5l-.7-.55c-.15-.1-.5-.45-1-1.1l-.1-.1c.2-.15.4-.35.6-.55l1.95-1.85 1.1-1c1-1 1.7-1.65 2.1-1.9l.5-.35c.4-.25.65-.45.75-.45.2-.15.45-.35.65-.6s.3-.5.3-.7l-.3-.65c-.55.2-1.2.65-2.05 1.35-.85.75-1.65 1.55-2.5 2.5-.8.9-1.6 1.65-2.4 2.3-.8.65-1.4.95-1.9 1-.15 0-1.5-1.05-4.1-3.2C3.1 2.6 1.45 1.2.7.55L.45.1c-.1.05-.2.15-.3.3C.05.55 0 .7 0 .85l.05.35.05.4 1.2 1 5.2 4.15c.1.05.3.2.6.5l.7.6c.15.1.5.45 1 1.1l.1.1c-.2.15-.4.35-.6.55l-1.95 1.85-1.1 1c-1 1-1.7 1.65-2.1 1.9l-.5.35c-.4.25-.65.45-.75.45-.25.15-.45.35-.65.6-.15.3-.25.55-.25.75l.3.65c.55-.2 1.2-.65 2.05-1.35.85-.75 1.65-1.55 2.5-2.5.8-.9 1.6-1.65 2.4-2.3.8-.65 1.4-.95 1.9-1 .15 0 1.5 1.05 4.1 3.2 2.6 2.15 4.3 3.55 5.05 4.2l.2.45c.1-.05.2-.15.3-.3.1-.15.15-.3.15-.45z"
                  ></path>
                </svg>
              </button>
            </div>
            <div className="edit-inner">
              <form onSubmit={addEpisodesData}>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <label htmlFor="episode_number">Episode Number</label>
                      <NumberInput
                        id="episode_number"
                        name="episode_number"
                        placeholder="Enter Episode Number"
                        ref={episodeNumberRefFocus}
                        onChange={onChange}
                        value={episodeData.episode_number}
                      />
                      <span className="text-danger pt-2">
                        {errors?.episode_number}
                      </span>
                    </div>
                    <div className="form-group">
                      <label htmlFor="title">Title</label>
                      <input
                        type="text"
                        id="title"
                        name="title"
                        placeholder="Enter Episode Title"
                        ref={titleRefFocus}
                        onChange={onChange}
                        value={episodeData.title}
                      />
                      <span className="text-danger pt-2">{errors?.title}</span>
                    </div>
                    <div className="form-group">
                      <label htmlFor="description">Description</label>
                      <textarea
                        id="description"
                        name="description"
                        placeholder="Enter Description"
                        ref={descriptionRefFocus}
                        onChange={onChange}
                        value={episodeData.description}
                      ></textarea>
                      <span className="text-danger pt-2">
                        {errors?.description}
                      </span>
                    </div>
                    <div className="form-group">
                      <label htmlFor="coin">Coin</label>
                      <NumberInput
                        id="coin"
                        name="coin"
                        placeholder="Enter Coin"
                        ref={coinRefFocus}
                        onChange={onChange}
                        value={episodeData.coin}
                      />
                      <span className="text-danger pt-2">{errors?.coin}</span>
                    </div>
                    <div className="form-group">
                      <label htmlFor="tags">Genres</label>
                      <Select2Component
                        ref={tagsRefFocus}
                        value={episodeData.tags}
                        options={tagList}
                        name={"tags"}
                        placeholder={"Search by genres"}
                        onChange={onChangeSelect2}
                        isMulti
                      />
                      <span className="text-danger pt-2">{errors?.tags}</span>
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="form-group">
                      <CustomVideoBox
                        videoUrl={
                          !isEmpty(filePreview)
                            ? filePreview
                            : "https://flixy.retrytech.site/assets/img/placeholder-image.png"
                        }
                        onChange={handleImage}
                        label={"Video"}
                        name="video_url"
                        ref={coverVideoRefFocus}
                      />
                      {episodeData.id !== 0 && (
                        <button
                          type="button"
                          onClick={handlePreviewEditVideo}
                          style={{
                            marginTop: "8px",
                            padding: "6px 14px",
                            fontSize: "13px",
                            cursor: "pointer",
                            background: "rgba(255,255,255,0.05)",
                            border: "1px solid rgba(255,255,255,0.18)",
                            borderRadius: "6px",
                            color: "var(--body-text-color, #ccc)",
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "6px",
                          }}
                        >
                          <i className="fas fa-play-circle" />
                          Preview Video
                        </button>
                      )}
                      <span className="text-danger pt-2">
                        {errors?.video_url}
                      </span>
                    </div>
                  </div>
                  <div className="col-12">
                    {isUploading && (
                      <div style={{ marginBottom: "12px", padding: "0 4px" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "6px",
                            fontSize: "13px",
                            color: "var(--body-text-color)",
                          }}
                        >
                          <span>{uploadStatus || "Uploading..."}</span>
                          {uploadProgress != null && (
                            <strong>{uploadProgress}%</strong>
                          )}
                        </div>
                        <div
                          style={{
                            background: "rgba(255,255,255,0.1)",
                            borderRadius: "6px",
                            height: "8px",
                            overflow: "hidden",
                          }}
                        >
                          {uploadProgress != null ? (
                            <div
                              style={{
                                width: `${uploadProgress}%`,
                                height: "100%",
                                background: "var(--first-color)",
                                borderRadius: "6px",
                                transition: "width 0.25s ease",
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                background: `linear-gradient(90deg, transparent 0%, var(--first-color) 50%, transparent 100%)`,
                                borderRadius: "6px",
                                animation:
                                  "progressIndeterminate 1.2s ease-in-out infinite",
                              }}
                            />
                          )}
                        </div>
                      </div>
                    )}
                    <div className="action-footer">
                      <button
                        className="btn"
                        disabled={
                          isUploading ||
                          (showModel.title === "Add"
                            ? addEpisodesLoading.loading
                            : updateEpisodesLoading.loading)
                        }
                      >
                        {isUploading ? (
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <div
                              className="spinner-border text-light"
                              style={{ width: "14px", height: "14px" }}
                              role="status"
                            >
                              <span className="visually-hidden">
                                Uploading...
                              </span>
                            </div>
                            Uploading {uploadProgress}%
                          </span>
                        ) : (
                            showModel.title === "Add"
                              ? addEpisodesLoading.loading
                              : updateEpisodesLoading.loading
                          ) ? (
                          <div
                            className="spinner-border text-light"
                            style={{ width: "16px", height: "16px" }}
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          "💾 Save"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </Model>
        )}

        {showUrlModel && (
          <div className="common-popup edit-popup active">
            <div className="edit-heading d-flex align-items-center justify-content-between">
              <h3>Add Episodes Url</h3>
              <button
                className="common-close edit-close-btn"
                onClick={(e) => closeUrlModel()}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="18"
                  viewBox="0 0 20 18"
                >
                  <path
                    fill="#ffffff"
                    d="M19.95 16.75l-.05-.4-1.2-1-5.2-4.2c-.1-.05-.3-.2-.6-.5l-.7-.55c-.15-.1-.5-.45-1-1.1l-.1-.1c.2-.15.4-.35.6-.55l1.95-1.85 1.1-1c1-1 1.7-1.65 2.1-1.9l.5-.35c.4-.25.65-.45.75-.45.2-.15.45-.35.65-.6s.3-.5.3-.7l-.3-.65c-.55.2-1.2.65-2.05 1.35-.85.75-1.65 1.55-2.5 2.5-.8.9-1.6 1.65-2.4 2.3-.8.65-1.4.95-1.9 1-.15 0-1.5-1.05-4.1-3.2C3.1 2.6 1.45 1.2.7.55L.45.1c-.1.05-.2.15-.3.3C.05.55 0 .7 0 .85l.05.35.05.4 1.2 1 5.2 4.15c.1.05.3.2.6.5l.7.6c.15.1.5.45 1 1.1l.1.1c-.2.15-.4.35-.6.55l-1.95 1.85-1.1 1c-1 1-1.7 1.65-2.1 1.9l-.5.35c-.4.25-.65.45-.75.45-.25.15-.45.35-.65.6-.15.3-.25.55-.25.75l.3.65c.55-.2 1.2-.65 2.05-1.35.85-.75 1.65-1.55 2.5-2.5.8-.9 1.6-1.65 2.4-2.3.8-.65 1.4-.95 1.9-1 .15 0 1.5 1.05 4.1 3.2 2.6 2.15 4.3 3.55 5.05 4.2l.2.45c.1-.05.2-.15.3-.3.1-.15.15-.3.15-.45z"
                  ></path>
                </svg>
              </button>
            </div>

            <div className="edit-inner">
              <form onSubmit={addEpisodeLinkData}>
                <div className="row">
                  {urlFields.map((url, index) => (
                    <div className="col-12 mb-2" key={index}>
                      <div className="d-flex align-items-center">
                        <input
                          type="url"
                          className="form-control"
                          placeholder={`Enter Episode Url ${index + 1}`}
                          value={url}
                          onChange={(e) => handleChange(index, e.target.value)}
                        />
                        {index === urlFields.length - 1 ? (
                          <button
                            type="button"
                            className="btn btn-success ms-2"
                            onClick={handleAddField}
                          >
                            <i className="fas fa-plus"></i>
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-danger ms-2"
                            onClick={() => handleRemoveField(index)}
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        )}
                      </div>
                      <span className="text-danger d-inline pt-1">
                        {errors[`url${index}`]}
                      </span>
                    </div>
                  ))}
                  <div className="col-12">
                    <div className="action-footer">
                      <button
                        className="btn"
                        disabled={addEpisodesUrlsLoading.loading}
                      >
                        {addEpisodesUrlsLoading.loading ? (
                          <div
                            className="spinner-border text-light"
                            style={{ width: "16px", height: "16px" }}
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          "💾 Save"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Bulk Upload Custom CSS */}
        <style>{`
                                            .bulk-modal-overlay {
                                                position: fixed;
                                                top: 0;
                                                left: 0;
                                                right: 0;
                                                bottom: 0;
                                                background: rgba(0, 0, 0, 0.7);
                                                z-index: 1035;
                                                backdrop-filter: blur(8px);
                                                opacity: 0;
                                                visibility: hidden;
                                                transition: all 0.3s ease;
                                            }
                                            .bulk-modal-overlay.active {
                                                opacity: 1;
                                                visibility: visible;
                                            }
                                            .bulk-upload-modal {
                                                position: fixed;
                                                top: 50%;
                                                left: 50%;
                                                transform: translate(-50%, -50%) scale(0.95);
                                                width: 95%;
                                                max-width: 1100px;
                                                height: 85vh;
                                                background: var(--card-bg, #1e1e2f);
                                                border: 1px solid var(--border-color, rgba(255,255,255,0.08));
                                                box-shadow: var(--shadow-lg, 0 15px 40px rgba(0,0,0,0.5));
                                                border-radius: var(--radius-lg, 12px);
                                                z-index: 1040;
                                                display: flex;
                                                flex-direction: column;
                                                color: var(--body-text-color, #ccc);
                                                opacity: 0;
                                                visibility: hidden;
                                                transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
                                                overflow: hidden;
                                            }
                                            .bulk-upload-modal.active {
                                                opacity: 1;
                                                visibility: visible;
                                                transform: translate(-50%, -50%) scale(1);
                                            }
                                            .bulk-modal-header {
                                                padding: 16px 24px;
                                                border-bottom: 1px solid var(--border-color, rgba(255,255,255,0.08));
                                                display: flex;
                                                justify-content: space-between;
                                                align-items: center;
                                                background: rgba(0, 0, 0, 0.1);
                                            }
                                            .bulk-modal-header h3 {
                                                margin: 0;
                                                font-size: 1.25rem;
                                                font-weight: 600;
                                                color: var(--white, #fff);
                                            }
                                            .bulk-modal-body {
                                                flex: 1;
                                                display: flex;
                                                overflow: hidden;
                                                padding: 0;
                                            }
                                            .bulk-left-pane {
                                                width: 40%;
                                                border-right: 1px solid var(--border-color, rgba(255,255,255,0.08));
                                                display: flex;
                                                flex-direction: column;
                                                background: rgba(0, 0, 0, 0.15);
                                            }
                                            .bulk-right-pane {
                                                width: 60%;
                                                display: flex;
                                                flex-direction: column;
                                                background: rgba(0, 0, 0, 0.05);
                                            }
                                            .bulk-dropzone {
                                                padding: 24px 16px;
                                                border: 2px dashed rgba(255, 255, 255, 0.15);
                                                border-radius: var(--radius-md, 8px);
                                                margin: 16px;
                                                text-align: center;
                                                cursor: pointer;
                                                transition: all 0.2s;
                                                background: rgba(255, 255, 255, 0.01);
                                                display: flex;
                                                flex-direction: column;
                                                align-items: center;
                                                gap: 8px;
                                            }
                                            .bulk-dropzone:hover {
                                                border-color: var(--first-color, #00a8f3);
                                                background: rgba(255, 255, 255, 0.03);
                                            }
                                            .bulk-file-list {
                                                flex: 1;
                                                overflow-y: auto;
                                                padding: 0 16px 16px;
                                            }
                                            .bulk-file-item {
                                                padding: 12px;
                                                border-radius: var(--radius-sm, 6px);
                                                background: rgba(255, 255, 255, 0.02);
                                                border: 1px solid var(--border-color, rgba(255,255,255,0.08));
                                                margin-bottom: 10px;
                                                cursor: pointer;
                                                transition: all 0.2s;
                                                position: relative;
                                                display: flex;
                                                flex-direction: column;
                                                gap: 6px;
                                            }
                                            .bulk-file-item:hover {
                                                background: rgba(255, 255, 255, 0.04);
                                            }
                                            .bulk-file-item.active {
                                                background: rgba(var(--first-color-rgb, 0, 168, 243), 0.08);
                                                border-color: var(--first-color, #00a8f3);
                                            }
                                            .bulk-file-item.has-error {
                                                border-color: var(--error-color, #ef4444);
                                            }
                                            .bulk-pane-header {
                                                padding: 16px 24px;
                                                border-bottom: 1px solid var(--border-color, rgba(255,255,255,0.08));
                                                font-size: 0.95rem;
                                                font-weight: 500;
                                                color: var(--text-color, #cbd5e1);
                                                display: flex;
                                                justify-content: space-between;
                                                align-items: center;
                                            }
                                            .bulk-form-container {
                                                flex: 1;
                                                overflow-y: auto;
                                                padding: 24px;
                                            }
                                            .bulk-modal-footer {
                                                padding: 16px 24px;
                                                border-top: 1px solid var(--border-color, rgba(255,255,255,0.08));
                                                display: flex;
                                                justify-content: space-between;
                                                align-items: center;
                                                background: rgba(0, 0, 0, 0.1);
                                            }
                                            .minimized-upload-widget {
                                                position: fixed;
                                                bottom: 24px;
                                                right: 24px;
                                                width: 360px;
                                                background: var(--card-bg, #1e1e2f);
                                                border: 1px solid var(--border-color, rgba(255,255,255,0.15));
                                                box-shadow: var(--shadow-lg, 0 10px 30px rgba(0, 0, 0, 0.5));
                                                border-radius: var(--radius-md, 8px);
                                                z-index: 1050;
                                                overflow: hidden;
                                                color: var(--body-text-color, #ccc);
                                                transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                                                backdrop-filter: blur(15px);
                                            }
                                            .minimized-widget-header {
                                                padding: 12px 16px;
                                                background: rgba(0, 0, 0, 0.2);
                                                border-bottom: 1px solid var(--border-color, rgba(255,255,255,0.08));
                                                display: flex;
                                                justify-content: space-between;
                                                align-items: center;
                                            }
                                            .minimized-widget-body {
                                                padding: 16px;
                                            }
                                        `}</style>

        {/* Bulk Upload Modal */}
        <div
          className={`bulk-modal-overlay ${showBulkModel && !isBulkMinimized ? "active" : ""}`}
          onClick={() => {
            setIsBulkMinimized(true);
            $("body").removeClass("no_scroll");
            $(".overlay").removeClass("qv_active");
          }}
        />

        <div
          className={`bulk-upload-modal ${showBulkModel && !isBulkMinimized ? "active" : ""}`}
        >
          <div className="bulk-modal-header">
            <div>
              <h3>Bulk Upload Episodes</h3>
              <small style={{ color: "var(--text-color)", opacity: 0.8 }}>
                Series: {seriesTitle}
              </small>
            </div>
            <div className="d-flex align-items-center gap-2">
              <button
                className="btn btn-sm btn-secondary"
                style={{ padding: "4px 10px", fontSize: "12px" }}
                onClick={() => {
                  setIsBulkMinimized(true);
                  $("body").removeClass("no_scroll");
                  $(".overlay").removeClass("qv_active");
                }}
                title="Minimize & Keep Uploading"
              >
                <i className="fas fa-minus me-1" /> Minimize
              </button>
              <button
                className="common-close edit-close-btn"
                style={{ position: "static" }}
                onClick={() => {
                  const hasActive = bulkEpisodes.some(
                    (ep) =>
                      ep.status === "uploading" || ep.status === "presigning",
                  );
                  if (hasActive) {
                    Swal.fire({
                      title: "Cancel upload?",
                      text: "Active uploads will be cancelled. Are you sure?",
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "var(--first-color)",
                      cancelButtonColor: "var(--error-color)",
                      confirmButtonText: "Yes, cancel them",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        setShowBulkModel(false);
                        setBulkEpisodes([]);
                        setBulkErrors({});
                        $("body").removeClass("no_scroll");
                        $(".overlay").removeClass("qv_active");
                      }
                    });
                  } else {
                    setShowBulkModel(false);
                    setBulkEpisodes([]);
                    setBulkErrors({});
                    $("body").removeClass("no_scroll");
                    $(".overlay").removeClass("qv_active");
                  }
                }}
              >
                &#x2715;
              </button>
            </div>
          </div>

          <div className="bulk-modal-body">
            {/* Left Pane: Dropzone and Upload List */}
            <div className="bulk-left-pane">
              <div
                className="bulk-dropzone"
                onClick={() =>
                  document.getElementById("bulk-file-input").click()
                }
              >
                <i
                  className="fas fa-cloud-upload-alt"
                  style={{ fontSize: "32px", color: "var(--first-color)" }}
                />
                <div>
                  <strong>Drag & drop video files</strong> or{" "}
                  <span style={{ color: "var(--first-color)" }}>browse</span>
                </div>
                <small style={{ color: "var(--text-color)", opacity: 0.6 }}>
                  Supports mp4, mov, avi, mkv, webm
                </small>
                <input
                  id="bulk-file-input"
                  type="file"
                  multiple
                  accept="video/mp4, video/webm, video/ogg, video/avi, video/quicktime, video/x-msvideo, video/x-matroska"
                  style={{ display: "none" }}
                  onChange={handleBulkFileSelect}
                />
              </div>

              <div className="bulk-file-list">
                {bulkEpisodes.length === 0 ? (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "40px 20px",
                      color: "var(--text-color)",
                      opacity: 0.5,
                    }}
                  >
                    <i
                      className="fas fa-video"
                      style={{ fontSize: "24px", marginBottom: "8px" }}
                    />
                    <div>No files added yet</div>
                  </div>
                ) : (
                  bulkEpisodes.map((ep) => {
                    const hasErr = !!bulkErrors[ep.id];
                    const isActive = selectedEpisodeId === ep.id;
                    return (
                      <div
                        key={ep.id}
                        className={`bulk-file-item ${isActive ? "active" : ""} ${hasErr ? "has-error" : ""}`}
                        onClick={() => setSelectedEpisodeId(ep.id)}
                      >
                        <div
                          className="d-flex align-items-center justify-content-between"
                          style={{ gap: "10px" }}
                        >
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div
                              style={{
                                fontWeight: 500,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                fontSize: "13px",
                                color: "var(--white)",
                              }}
                            >
                              {ep.filename}
                            </div>
                            <small
                              style={{
                                color: "var(--text-color)",
                                opacity: 0.7,
                              }}
                            >
                              {ep.size}
                            </small>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            {ep.status === "completed" && (
                              <i
                                className="fas fa-check-circle"
                                style={{ color: "#10b981" }}
                              />
                            )}
                            {ep.status === "failed" && (
                              <button
                                className="btn btn-sm btn-warning"
                                style={{ padding: "2px 6px", fontSize: "10px" }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  uploadBulkFile(ep.id, ep.file);
                                }}
                                title="Retry Upload"
                              >
                                <i className="fas fa-sync-alt" />
                              </button>
                            )}
                            <button
                              className="btn btn-sm btn-link text-danger"
                              style={{ padding: "2px 6px" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                removeBulkEpisode(ep.id);
                              }}
                              title="Remove"
                            >
                              <i className="fas fa-trash-alt" />
                            </button>
                          </div>
                        </div>

                        {/* Progress bar */}
                        {ep.status === "uploading" && (
                          <div
                            style={{
                              width: "100%",
                              height: "4px",
                              background: "rgba(255,255,255,0.1)",
                              borderRadius: "2px",
                              overflow: "hidden",
                              marginTop: "4px",
                            }}
                          >
                            <div
                              style={{
                                width: `${ep.progress}%`,
                                height: "100%",
                                background: "var(--first-color)",
                                borderRadius: "2px",
                                transition: "width 0.1s",
                              }}
                            />
                          </div>
                        )}
                        {ep.status === "presigning" && (
                          <div
                            style={{
                              width: "100%",
                              height: "4px",
                              background: "rgba(255,255,255,0.1)",
                              borderRadius: "2px",
                              overflow: "hidden",
                              marginTop: "4px",
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                background:
                                  "linear-gradient(90deg, transparent, var(--first-color), transparent)",
                                animation:
                                  "progressIndeterminate 1.2s infinite",
                              }}
                            />
                          </div>
                        )}

                        <div
                          className="d-flex align-items-center justify-content-between"
                          style={{ fontSize: "11px", marginTop: "2px" }}
                        >
                          <span
                            style={{
                              color:
                                ep.status === "completed"
                                  ? "#10b981"
                                  : ep.status === "failed"
                                    ? "#ef4444"
                                    : "var(--text-color)",
                            }}
                          >
                            {ep.status === "presigning" && "Preparing upload…"}
                            {ep.status === "uploading" &&
                              `Uploading ${ep.progress}%`}
                            {ep.status === "completed" && "Ready"}
                            {ep.status === "failed" && "Upload failed"}
                            {ep.status === "queued" && "Queued"}
                          </span>
                          {hasErr && (
                            <span style={{ color: "#ef4444", fontWeight: 600 }}>
                              ⚠ Error
                            </span>
                          )}
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>

            {/* Right Pane: Form for Selected Episode */}
            <div className="bulk-right-pane">
              {selectedEpisodeId ? (
                (() => {
                  const selectedEp = bulkEpisodes.find(
                    (ep) => ep.id === selectedEpisodeId,
                  );
                  if (!selectedEp) return null;
                  const errs = bulkErrors[selectedEpisodeId] || {};
                  return (
                    <React.Fragment key={selectedEpisodeId}>
                      <div className="bulk-pane-header">
                        <span style={{ fontWeight: 600 }}>
                          Edit Details: {selectedEp.filename}
                        </span>
                        <span className="badge bg-secondary">
                          {selectedEp.size}
                        </span>
                      </div>
                      <div className="bulk-form-container">
                        <div className="row">
                          <div className="col-sm-6 col-12">
                            <div className="form-group">
                              <label htmlFor="bulk_ep_num">
                                Episode Number{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <NumberInput
                                id="bulk_ep_num"
                                name="episode_number"
                                placeholder="Enter Episode Number"
                                value={selectedEp.metadata.episode_number}
                                onChange={(e) =>
                                  updateEpisodeMetadata(
                                    selectedEp.id,
                                    "episode_number",
                                    e.target.value,
                                  )
                                }
                              />
                              {errs.episode_number && (
                                <span
                                  className="text-danger pt-2 d-block"
                                  style={{ fontSize: "12px" }}
                                >
                                  {errs.episode_number}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-6 col-12">
                            <div className="form-group">
                              <label htmlFor="bulk_season_num">
                                Season Number
                              </label>
                              <NumberInput
                                id="bulk_season_num"
                                name="season_number"
                                placeholder="Enter Season Number"
                                value={selectedEp.metadata.season_number}
                                onChange={(e) =>
                                  updateEpisodeMetadata(
                                    selectedEp.id,
                                    "season_number",
                                    e.target.value,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="form-group">
                              <label htmlFor="bulk_title">
                                Title <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                id="bulk_title"
                                name="title"
                                placeholder="Enter Episode Title"
                                value={selectedEp.metadata.title}
                                onChange={(e) =>
                                  updateEpisodeMetadata(
                                    selectedEp.id,
                                    "title",
                                    e.target.value,
                                  )
                                }
                              />
                              {errs.title && (
                                <span
                                  className="text-danger pt-2 d-block"
                                  style={{ fontSize: "12px" }}
                                >
                                  {errs.title}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-6 col-12">
                            <div className="form-group">
                              <label htmlFor="bulk_coin">Coin</label>
                              <NumberInput
                                id="bulk_coin"
                                name="coin"
                                placeholder="Enter Coin"
                                value={selectedEp.metadata.coin}
                                onChange={(e) =>
                                  updateEpisodeMetadata(
                                    selectedEp.id,
                                    "coin",
                                    e.target.value,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-sm-6 col-12">
                            <div className="form-group">
                              <label htmlFor="bulk_sort">Sort Order</label>
                              <NumberInput
                                id="bulk_sort"
                                name="sort_order"
                                placeholder="Enter Sort Order"
                                value={selectedEp.metadata.sort_order}
                                onChange={(e) =>
                                  updateEpisodeMetadata(
                                    selectedEp.id,
                                    "sort_order",
                                    e.target.value,
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="form-group">
                              <label htmlFor="bulk_tags">
                                Genres (Optional)
                              </label>
                              <Select2Component
                                value={selectedEp.metadata.tags}
                                options={tagList}
                                name={"bulk-tags"}
                                placeholder={"Search by genres"}
                                onChange={(val) =>
                                  updateEpisodeMetadata(
                                    selectedEp.id,
                                    "tags",
                                    val,
                                  )
                                }
                                isMulti
                              />
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="form-group">
                              <label htmlFor="bulk_desc">Description</label>
                              <textarea
                                id="bulk_desc"
                                name="description"
                                placeholder="Enter Description"
                                value={selectedEp.metadata.description}
                                onChange={(e) =>
                                  updateEpisodeMetadata(
                                    selectedEp.id,
                                    "description",
                                    e.target.value,
                                  )
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })()
              ) : (
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "var(--text-color)",
                    opacity: 0.5,
                    padding: "20px",
                  }}
                >
                  <i
                    className="fas fa-edit"
                    style={{ fontSize: "32px", marginBottom: "12px" }}
                  />
                  <h5>No Episode Selected</h5>
                  <p style={{ margin: 0, fontSize: "13px" }}>
                    Select an episode from the left list to edit details
                  </p>
                </div>
              )}
            </div>
          </div>

          <div className="bulk-modal-footer">
            <div style={{ color: "var(--text-color)", fontSize: "13px" }}>
              {(() => {
                const total = bulkEpisodes.length;
                const completed = bulkEpisodes.filter(
                  (e) => e.status === "completed",
                ).length;
                const failed = bulkEpisodes.filter(
                  (e) => e.status === "failed",
                ).length;
                return `Total: ${total} | Uploaded: ${completed}${failed > 0 ? ` | Failed: ${failed}` : ""}`;
              })()}
            </div>
            <div className="d-flex gap-2">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  const hasActive = bulkEpisodes.some(
                    (ep) =>
                      ep.status === "uploading" || ep.status === "presigning",
                  );
                  if (hasActive) {
                    Swal.fire({
                      title: "Cancel upload?",
                      text: "Active uploads will be cancelled. Are you sure?",
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "var(--first-color)",
                      cancelButtonColor: "var(--error-color)",
                      confirmButtonText: "Yes, cancel them",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        setShowBulkModel(false);
                        setBulkEpisodes([]);
                        setBulkErrors({});
                        $("body").removeClass("no_scroll");
                        $(".overlay").removeClass("qv_active");
                      }
                    });
                  } else {
                    setShowBulkModel(false);
                    setBulkEpisodes([]);
                    setBulkErrors({});
                    $("body").removeClass("no_scroll");
                    $(".overlay").removeClass("qv_active");
                  }
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                disabled={
                  bulkSubmitting ||
                  bulkEpisodes.length === 0 ||
                  bulkEpisodes.some((e) => e.status !== "completed")
                }
                onClick={submitBulkEpisodes}
              >
                {bulkSubmitting ? (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <div
                      className="spinner-border text-light"
                      style={{ width: "14px", height: "14px" }}
                      role="status"
                    />
                    Saving...
                  </span>
                ) : (
                  "💾 Save All Episodes"
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Minimized Background Upload Widget */}
        {showBulkModel && isBulkMinimized && bulkEpisodes.length > 0 && (
          <div className="minimized-upload-widget">
            <div className="minimized-widget-header">
              <strong style={{ fontSize: "13px" }}>
                {isUploadComplete ? (
                  <i
                    className="fas fa-check-circle me-2"
                    style={{ color: "var(--success-color)" }}
                  />
                ) : (
                  <i
                    className="fas fa-spinner fa-spin me-2"
                    style={{ color: "var(--first-color)" }}
                  />
                )}
                {isUploadComplete ? "Ready to Save (" : "Uploading Episodes ("}
                {bulkEpisodes.filter((e) => e.status === "completed").length}/
                {bulkEpisodes.length})
              </strong>
              <div className="d-flex align-items-center gap-2">
                <button
                  className="btn btn-sm btn-link text-white"
                  style={{ padding: "0 4px", fontSize: "14px" }}
                  onClick={() => {
                    setIsBulkMinimized(false);
                    $("body").addClass("no_scroll");
                    $(".overlay").addClass("qv_active");
                  }}
                  title="Expand Editor"
                >
                  <i className="fas fa-expand-alt" />
                </button>
                <button
                  className="btn btn-sm btn-link text-danger"
                  style={{ padding: "0 4px", fontSize: "14px" }}
                  onClick={() => {
                    const hasActive = bulkEpisodes.some(
                      (ep) =>
                        ep.status === "uploading" ||
                        ep.status === "presigning",
                    );
                    if (hasActive) {
                      Swal.fire({
                        title: "Cancel upload?",
                        text: "Active uploads will be cancelled. Are you sure?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "var(--first-color)",
                        cancelButtonColor: "var(--error-color)",
                        confirmButtonText: "Yes, cancel them",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          setShowBulkModel(false);
                          setBulkEpisodes([]);
                          setBulkErrors({});
                        }
                      });
                    } else {
                      setShowBulkModel(false);
                      setBulkEpisodes([]);
                      setBulkErrors({});
                    }
                  }}
                  title="Cancel All"
                >
                  &#x2715;
                </button>
              </div>
            </div>
            <div className="minimized-widget-body">
              {(() => {
                const total = bulkEpisodes.length;
                const overallProgress =
                  total > 0
                    ? Math.round(
                        bulkEpisodes.reduce(
                          (acc, ep) =>
                            acc +
                            (ep.status === "completed"
                              ? 100
                              : ep.status === "uploading"
                                ? ep.progress
                                : 0),
                          0,
                        ) / total,
                      )
                    : 0;
                return (
                  <div>
                    <div
                      className="d-flex justify-content-between mb-2"
                      style={{ fontSize: "12px" }}
                    >
                      <span>Overall Progress</span>
                      <strong>{overallProgress}%</strong>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        height: "6px",
                        background: "rgba(255,255,255,0.1)",
                        borderRadius: "3px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          width: `${overallProgress}%`,
                          height: "100%",
                          background: "var(--first-color)",
                          borderRadius: "3px",
                          transition: "width 0.2s",
                        }}
                      />
                    </div>
                    {bulkEpisodes.some((e) => e.status === "failed") && (
                      <small
                        style={{
                          color: "#ef4444",
                          display: "block",
                          marginTop: "8px",
                        }}
                      >
                        ⚠ Some uploads failed. Open editor to retry.
                      </small>
                    )}
                  </div>
                );
              })()}
            </div>
          </div>
        )}
      </>
      {/* } */}
    </>
  );
};

export default Episodes;
